import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './pages/Home';
import Login from './components/Auth/Login';
import Register from './components/Auth/Register';
import CreateCard from './pages/CreateCard';
import BulkCreateCard from './pages/BulkCreateCard';
import EditCard from './pages/EditCard'; // Importa la pagina EditCard
import SuperAdminDashboard from './pages/SuperAdminDashboard';
import { AuthProvider } from './context/AuthContext';
import Header from './components/Layout/Header';
import Footer from './components/Layout/Footer';
import PrivateRoute from './components/PrivateRoute';
import StaticRedirect from './components/StaticRedirect';


const App = () => {
  return (
    <AuthProvider>
      <Router>
        <div className="flex flex-col min-h-screen">
          <Header />
          <main className="flex-grow">
            <Routes>
              <Route path="/api/static/*" element={<StaticRedirect />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/" element={<PrivateRoute><Home /></PrivateRoute>} />
              <Route path="/create-card" element={<PrivateRoute><CreateCard /></PrivateRoute>} />
              <Route path="/bulk-create" element={<PrivateRoute><BulkCreateCard /></PrivateRoute>} />
              <Route path="/edit/:id" element={<PrivateRoute><EditCard /></PrivateRoute>} />
              <Route
                path="/admin"
                element={
                  <PrivateRoute roles={['superadmin']}>
                    <SuperAdminDashboard />
                  </PrivateRoute>
                }
              />
            </Routes>
          </main>
          <Footer />
        </div>
      </Router>
    </AuthProvider>
  );
};

export default App;
